import { render } from "./App.vue?vue&type=template&id=b8a120aa"
const script = {}

import "./App.vue?vue&type=style&index=0&id=b8a120aa&lang=css"

import exportComponent from "D:\\Git\\Nakhoncity\\Nakhoncity-App-Queue-Idcard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__